<template>
  <div class="p-login" style="height: 100%;overflow: hidden;">
    <div class="pcStyle-login">
      <Header :showNav="false"/>
      <div class="p-sc-login">
        <div class="p-sc-login__container">
          <div class="p-sc-login__container-left" :class="{'wx-login__container__left': type === 3}">
            <div v-show="type !== 3" class="p-sc-login__container-left-title">
              <span>账号登陆</span>
            </div>
            <div v-show="type === 1">
              <div class="p-sc-login__container-left-username">
                <input v-model="account" type="text" placeholder="用户名">
              </div>
              <div class="p-sc-login__container-left-pass">
                <input v-model="password" type="password" placeholder="密码">
              </div>
              <!-- <div class="p-sc-login__container-left-code">
                                <input type="text" placeholder="验证码">
                                <img src="" alt="">
                                <span class="chage-code">换一张</span>
                            </div> -->
              <div class="p-sc-login__container-left-msgcode">
                <span @click="changeLoginType(2)">短信验证码登录</span>
              </div>
            </div>
            <div v-show="type === 2">
              <div class="p-sc-login__container-left-username">
                <input v-model="mobile" type="tel" placeholder="手机号">
              </div>
              <div class="p-sc-login__container-left-code p-sc-login__container-left-tel-code">
                <input v-model="verifycode" type="text" placeholder="验证码">
                <!-- <span class="msgcode-btn">发送手机验证码</span> -->
                <span @click="getMsgCode" :class="{'msgcode-btn-grey': msgcodeSending}" class="msgcode-btn">{{msgbtnText}}</span>
              </div>
              <div class="p-sc-login__container-left-msgcode">
                <span @click="changeLoginType(1)">账号密码登录</span>
              </div>
            </div>
            <div v-show="type === 3" style="text-align: center;">
              <!-- <div class="p-sc-login__container-left-qrlogin">
                                <span class="p-sc-login__container-left-qrlogin-tip">请使用微信扫一扫登录</span>
                                <span class="refresh">刷新</span>
                            </div>
                            <div class="p-sc-login__container-left-qrlogin-qr">
                                <img src="" alt="">
                                <div id="login_container"></div>

                            </div> -->
              <div id="login_container"></div>
              <div>
                <span @click="refreshQrCode" class="refresh">刷新</span>
                <span class="refresh" style="margin-left: 20px" @click="changeLoginType(1)">账号登陆</span>
              </div>
            </div>
            <div v-show="type !== 3">
              <div class="p-sc-login__container-left-login">
                <div @click="login" class="c-btn">登录</div>
              </div>
              <div class="p-sc-login__container-left-forget">
                <span @click="onForgetPass">忘记密码</span>
                <span @click="onRegister">注册</span>
              </div>
              <div class="dashed-line"></div>
              <div class="p-sc-login__container-left-qrcode">
                <img src="../assets/login/icon32_wx_logo.png" alt="">
                <span @click="changeLoginType(3)">微信二维码登录</span>
              </div>
            </div>
          </div>
          <div class="vertical-line"></div>
          <div class="p-sc-login__container-right">
            <div class="p-sc-login__container-right-title">
              <span>供应平台 精准对接</span>
            </div>
            <div class="p-sc-login__container-right-item">
              <ul>
                <li>项目发布</li>
                <li>需求对接</li>
                <li>匹配专家</li>
              </ul>
            </div>
            <div class="p-sc-login__container-right-desc">
              <p class="p-sc-login__container-right-desc--title">平台1.0升级</p>
              <p class="p-sc-login__container-right-desc--sub">在线对接，信息共享</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
    <div class="h5Style-login">
      <div class="p-login_h5__logo">
        <img src="../assets/login/logo.svg" alt="">
      </div>
      <div class="p-sc-login__container-left">
        <div class="p-sc-login__container-left-title">
          <span>账号登陆</span>
        </div>
        <div v-show="type === 1">
          <div class="p-sc-login__container-left-username">
            <input v-model="account" type="text" placeholder="用户名">
          </div>
          <div class="p-sc-login__container-left-pass">
            <input v-model="password" type="password" placeholder="密码">
          </div>

          <div class="p-sc-login__container-left-msgcode">
            <span @click="changeLoginType(2)">短信验证码登录</span>
          </div>
        </div>
        <div v-show="type === 2">
          <div class="p-sc-login__container-left-username">
            <input v-model="mobile" type="tel" placeholder="手机号">
          </div>
          <div class="p-sc-login__container-left-code p-sc-login__container-left-tel-code">
            <input v-model="verifycode" type="text" placeholder="验证码">
            <span @click="getMsgCode" :class="{'msgcode-btn-grey': msgcodeSending}" class="msgcode-btn">{{msgbtnText}}</span>
          </div>
          <div class="p-sc-login__container-left-msgcode">
            <span @click="changeLoginType(1)">账号密码登录</span>
          </div>
        </div>
        <!-- <div v-show="type === 3" style="text-align: center;">
                    <div class="p-sc-login__container-left-qrlogin">
                        <span class="p-sc-login__container-left-qrlogin-tip">请使用微信扫一扫登录</span>
                        <span class="refresh">刷新</span>
                    </div>
                    <div class="p-sc-login__container-left-qrlogin-qr">
                        <img src="" alt="">
                    </div>
                    <div>
                        <span @click="changeLoginType(1)">账号登陆</span>
                    </div>
                </div> -->
        <div v-show="type !== 3">
          <div class="p-sc-login__container-left-login">
            <div @click="login" class="c-btn">登录</div>
          </div>
          <div class="p-sc-login__container-left-forget">
            <span @click="onForgetPass">忘记密码</span>
            <span @click="onRegister">注册</span>
          </div>
          <div class="dashed-line"></div>
          <div class="p-sc-login__container-left-qrcode">
            <img src="../assets/login/icon48_wx_logo.png" alt="">
            <span @click="onMobileWxLogin">微信登录</span>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
  import Header from '@/components/Header.vue';
  import Footer from '@/components/Footer.vue';
  import './Home.css';

  import {
    loginApi,
    queryVerifycode,
    registerwithpwdApi,
    registerApi,
    setpasswordveriApi,
    queryWxWebAccesstoken,
    queryWxH5Accesstoken,
    wxBindwxApi,
    wxLoginApi,
  } from '@/api/login';

  import {setToken} from '@/utils/auth.js'

  export default {
    data() {
      return {
        type: 1, // 1：用户名，密码登录；2: 短信验证码； 3：微信扫码,
        account: '',
        password: '',
        verifycode: '',
        mobile: '',
        msgcodeSending: false,
        msgbtnText: '发送手机验证码',
        count: 0
      }
    },
    components: {
      Header,
      Footer
    },
    mounted() {},
    methods: {
      /**
       * 移动端微信登录
       */
      onMobileWxLogin() {
        // 需要区分是微信环境还是一般的浏览器环境。
        // 微信环境直接调取微信授权
        const authUrl =`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx39e84b0b854f1f0c&redirect_uri=http%3a%2f%2fwww.yunsmartcity.com%2f%23%2fbindCount&response_type=code&scope=snsapi_userinfo&state=sm#wechat_redirec`;
        // this.$http.get(authUrl)
        window.open(authUrl, '_self')
      },
      refreshQrCode() {
        const obj = new WxLogin({
          id: "login_container", // 需要显示的容器id
          appid: "wx9d165c26bfc5a384", // 公众号appid wx*******
          scope: "snsapi_login", // 网页默认即可
          redirect_uri: "http%3a%2f%2fwww.yunsmartcity.com%2f%23%2fbindCount", // 授权成功后回调的url
          state: "sm", // 可设置为简单的随机数加session用来校验
          style: "black", // 提供"black"、"white"可选。二维码的样式
          href: "" // 外部css文件url，需要https
        });
      },
      changeLoginType(t) {
        this.type = t;
        if (t === 3) {
          this.refreshQrCode();
        }
      },
      onForgetPass() {
        this.$router.push('/findpass');
      },
      onRegister() {
        this.$router.push('/register');
      },
      getMsgCode() {
        console.log("dddddddddd")
        if (this.msgcodeSending) {
          console.log("this.msgcodeSending----",this.msgcodeSending)
          return;
        }
        const mobile = this.mobile;
        if (!mobile) {
          this.$message.error('请输入手机号');
          return;
        }
        this.msgcodeSending = true;
        this.$http.get(queryVerifycode(), {
          mobile
        }).then(res => {
          this.msgbtnText = '60秒后重新获取';
          this.count = 60;
          this.countDown();
          console.log(res);
        }).catch((err) => {
          console.log("err-----",err)
          this.msgcodeSending = false;
        })
      },
      countDown() {
        if (this.count > 0) {
          setTimeout(() => {
            this.count -= 1;
            this.msgbtnText = `${this.count}秒后重新获取`;
            this.countDown();
          }, 1000)
        } else {
          this.msgcodeSending = false;
          this.msgbtnText = '发送手机验证码';
        }
      },
      login() {
        // 区分登录类型：  1 账号密码   2 短信验证码   3 微信
        if (this.type === 1) {
          this.accountLogin();
        }
        if (this.type === 2) {
          this.msgcodeLogin();
        }
      },
      msgcodeLogin() {
        const mobile = this.mobile;
        const verifycode = this.verifycode;
        if (!mobile) {
          this.$message.error('请输入手机号');
          return;
        }
        if (!verifycode) {
          this.$message.error('请输入验证码');
          return;
        }
        this.$http.apost(registerApi(), {
          account: mobile,
          verifycode
        }).then(res => {
          console.log(res);
          if (res.code === 1) {
            this.$message.success('登录成功')
            this.loginSuccess(res.data);
            return;
          }
          this.$message.error(res.msg || '服务器错误');
        }, err => {
          console.log(err);
        })
      },
      loginSuccess(userInfo) {
        console.log("userInfo----",userInfo)
        setToken(userInfo.oauth)
        window.localStorage.setItem('userInfo', JSON.stringify(userInfo));
        this.$router.push('/');
      },
      accountLogin() {
        const account = this.account;
        const password = this.password;
        if (!account) {
          this.$message.error('请输入用户名');
          return;
        }
        if (!password) {
          this.$message.error('请输入密码');
          return;
        }
        this.$http.apost(loginApi(), {
          account,
          password
        }).then(res => {
          console.log(res);
          if (res.code === 1) {
            // alert('登录成功')
            this.$message.success('登录成功');
            this.loginSuccess(res.data);
            return;
          }
          this.$message.error(res.msg || '服务器错误');
        }, err => {
          console.log(err);
        })
      }
    }
  }
</script>

<style scoped>
  .pcStyle-login {
    height: 100%;
  }

  body.h5Style .p-login {
    background: #FAFAFB;
  }

  .p-sc-login {
    margin-top: 74px;
    height: calc(100% - 134px);
  }

  .p-sc-login__container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 931px;
    height: 455px;
    background: #FFFFFF;
    border: 1px solid #979797;
  }

  .p-sc-login__container-left {
    padding: 38px 62px 54px 62px;
    width: 320px;
    display: inline-block;
  }

  .p-sc-login__container-left.wx-login__container__left {
    padding: 14px 62px 14px 62px;
  }

  .p-sc-login__container-left-title {
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: #333;
  }

  .p-sc-login__container-left-username,
  .p-sc-login__container-left-pass,
  .p-sc-login__container-left-code,
  .p-sc-login__container-left-login,
  .p-sc-login__container-left-msgcode,
  .p-sc-login__container-left-qrlogin {
    margin-top: 20px;
  }

  .p-sc-login__container-left-username input,
  .p-sc-login__container-left-pass input,
  .p-sc-login__container-left-code input {
    width: 100%;
    padding: 6px 16px;
    border: 1px solid #979797;
    box-sizing: border-box;
  }

  .p-sc-login__container-left-msgcode {
    text-align: right;
  }

  .p-sc-login__container-left-msgcode span {
    color: #1775F0;
    font-size: 12px;
    cursor: pointer;
  }

  .p-sc-login__container-left-code input {
    width: 128px;
  }

  .p-sc-login__container-left-code img {
    margin-left: 12px;
    width: 90px;
    display: inline-block;
  }

  .p-sc-login__container-left-code>.chage-code {
    margin-left: 20px;
  }

  .p-sc-login__container-left-login {
    background: #1775F0;
    text-align: center;
    color: #fff;
    height: 40px;
    line-height: 40px;
  }

  .p-sc-login__container-left-login .c-btn {
    cursor: pointer;
  }

  .p-sc-login__container-left-forget {
    color: #1775F0;
    font-size: 12px;
    margin: 13px 0px;
    display: flex;
    justify-content: space-between;
  }

  .p-sc-login__container-left-forget span {
    cursor: pointer;
  }

  .p-sc-login__container-left-qrcode {
    width: 100%;
    text-align: center;
    margin-top: 30px;
    color: #666;
    font-size: 14px;
  }

  .p-sc-login__container-left-qrcode span {
    cursor: pointer;
  }

  .dashed-line {
    border-bottom: dashed 1px #666;
  }

  .vertical-line {
    border: 1px solid #F0F0F0;
    height: 368px;
    display: inline-block;
    vertical-align: top;
    margin: 40px 28px 0 28px;
  }

  .p-sc-login__container-right {
    display: inline-block;
    vertical-align: top;
    padding: 62px;
  }

  .p-sc-login__container-right-title {
    font-size: 30px;
    color: #333;
  }

  .p-sc-login__container-right-item {
    margin-top: 20px;
    font-size: 14px;
    color: #666660;
  }

  .p-sc-login__container-right-item ul li {
    list-style: inside;
    padding: 5px;
  }

  .p-sc-login__container-right-desc {
    padding: 20px 30px;
    color: #fff;
    margin-top: 42px;
    background-image: linear-gradient(136deg, #908AFD 0%, #4B6CFF 100%);
    border-radius: 4px;
  }

  .p-sc-login__container-right-desc--title {
    font-size: 24px;
  }

  .p-sc-login__container-right-desc--sub {
    font-size: 16px;
  }

  .p-sc-login__container-left-tel-code {
    display: flex;
    justify-content: space-between;
  }

  .p-sc-login__container-left-tel-code input {
    width: 160px;
  }

  .msgcode-btn {
    background: #1775F0;
    color: #fff;
    width: 146px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    user-select: none;
  }

  .msgcode-btn-grey {
    background: #CCCCCC;
  }

  .p-sc-login__container-left-qrlogin {
    display: inline-flex;
    justify-content: space-between;
    width: 194px;
  }

  .p-sc-login__container-left-qrlogin-tip,
  .refresh {
    font-size: 14px;
  }

  .refresh {
    color: #4A90E2;
    cursor: pointer;
    user-select: none;
  }

  .p-sc-login__container-left-qrlogin-qr {
    width: 194px;
    height: 194px;
    display: inline-block;
    margin-top: 10px;
  }

  body.h5Style .pcStyle-login {
    display: none;
  }

  body.pcStyle .h5Style-login {
    display: none;
  }

  body.h5Style .p-sc-login__container-left {
    width: 100%;
    box-sizing: border-box;
    margin-top: 1.5rem;
  }

  body.h5Style .p-sc-login__container-left-title {
    font-size: .26rem;
  }

  body.h5Style .p-sc-login__container-left-username {
    margin-top: .58rem;
  }

  body.h5Style .p-sc-login__container-left-pass,
  body.h5Style .p-sc-login__container-left-code {
    margin-top: .44rem;
  }

  body.h5Style .p-sc-login__container-left-code input {
    width: 2.5rem;
  }

  body.h5Style .p-sc-login__container-left-code .change-code,
  body.h5Style .p-sc-login__container-left-forget,
  body.h5Style .p-sc-login__container-left-qrcode,
  body.h5Style .p-sc-login__container-left-msgcode span {
    font-size: .24rem;
  }

  body.h5Style .p-sc-login__container-left-login {
    margin-top: .52rem;
    height: .64rem;
    line-height: .64rem;
  }

  body.h5Style .p-sc-login__container-left-forget,
  body.h5Style .dashed-line {
    margin-top: .3rem;
  }

  body.h5Style .msgcode-btn {
    height: .62rem;
    width: 2.88rem;
    line-height: .62rem;
  }

  .p-login_h5__logo {
    text-align: center;
    margin-top: 100px;
  }

  .p-login_h5__logo img {
    margin-left: -20px;
  }
</style>
